import { EnumFilterDataManager } from 'src/app/base/shared/syncfusion/enum-filter-data-manager';
import { ParkerCreationType, ParkerTagUsage, ParkingSubscriptionDTO } from 'src/app/base/models/models.swagger.generated';
import { ModalService } from '../../../base/shared/modal/modal.service';
import { ClientDTO, Currency, FilterDTO, PagedResultDTOOfParkerDTO, ParkerClient, ParkerDTO, ParkerGroup, ParkerSubscriptionAssignmentDTO, ParkerTagDTO } from '../../../base/models/models.swagger.generated';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { ParkerAdministrationService, zipField } from './parker-administraton.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { ClientService } from '../../../base/services/client/client.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CommandClickEventArgs, FilterSettingsModel, IFilter, RowDataBoundEventArgs, ToolbarItems, GridModule } from '@syncfusion/ej2-angular-grids';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { ParkerFunctionComponent } from './parker-function/parker-function.component';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { EditParkerFormType } from './edit-parker-form/edit-parker-form.type';
import { Observable, of, Subscription } from 'rxjs';
import { ModalHelperService } from 'src/app/base/shared/modal-helper';
import { SfCommandButtonType, SfRequestTypes } from 'src/app/base/models/syncfusion-data';
import { EditParkerFormComponent } from './edit-parker-form/edit-parker-form.component';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { ParkerFilterComponent } from './parker-filter/parker-filter.component';
import { ClientAutocompleteComponent } from '../../../base/shared/client-autocomplete/client-autocomplete.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import { SyncfusionTranslationService } from 'src/app/base/services/syncfusion-translation.service';

enum ParkerLinkStatus {
  Unlinkable,
  ReadyToLink,
  LinkPending,
  Linked,
  LinkExpired
}

@Component({
    selector: 'app-parker-administration',
    templateUrl: './parker-administration.component.html',
    styleUrls: ['./parker-administration.component.scss'],
    imports: [
        TitleBarComponent,
        ClientAutocompleteComponent,
        ParkerFilterComponent,
        CheckBoxModule,
        SearchFieldComponent,
        GridModule,
        EditParkerFormComponent,
        ParkerFunctionComponent,
        TranslateModule,
    ]
})
export class ParkerAdministrationComponent extends GridBaseComponent implements OnInit, OnDestroy {
  @ViewChild('parkerFunctionDialog') public parkerFunctionDialog: ParkerFunctionComponent

  private toolbarItems: ToolbarItems[] | object = [
    { text: this.translateService.instant('i18n.domain.parker-administration.add-parker'), prefixIcon: "e-icons icon-add", id: 'add' },
    { text: "𝑓(x) " + this.translateService.instant('i18n.domain.parker-administration.function-button'), id: 'fnButton', disabled: true },
    'ColumnChooser'
  ];

  public toolbar: ToolbarItems[] | object = this.toolbarItems

  public currencyCheckBoxFilter = GridConstantsFactory.createCheckBoxFilter();
  public groupCheckBoxFilter = GridConstantsFactory.createCheckBoxFilter();
  public subscriptionAssignmentFilter: IFilter = { type: 'CheckBox'};
  public subscriptionAssignmentField = 'parkerSubscriptionAssignments';
  public filtermodel: FilterSettingsModel = { type: 'Menu' };

  private loadedParker = null;
  private subscriptionFilterSource = [];
  private translationSubscription: Subscription;

  public zipField = zipField;

  constructor(public parkerAdministrationService: ParkerAdministrationService,
    translateService: TranslateService,
    clientService: ClientService,
    private router: Router,
    private syncfusionTranslationService: SyncfusionTranslationService,
    private parkerClient: ParkerClient,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
    private modalHelperService: ModalHelperService) {
    super(clientService, translateService, parkerAdministrationService);
    this.parkerAdministrationService.subscriptionAssignmentFieldName = this.subscriptionAssignmentField;
    this.searchOptions = { fields: ['firstName', 'lastName', 'company.name', 'costCenter', 'title', 'identification'] };
    this.gridCommands = [
      {
        type: SfCommandButtonType.Edit,
        buttonOption:
        {
          cssClass: 'icon-btn',
          iconCss: 'icon-edit e-icons',
        },
      },
      {
        type: SfCommandButtonType.Delete,
        buttonOption:
        {
          cssClass: 'icon-btn',
          iconCss: 'icon-trash-can e-icons e-danger'
        }
      },
      {
        type: SfCommandButtonType.None,
        buttonOption:
        {
          cssClass: 'icon-btn',
          iconCss: 'e-icons',
        }
      },
    ];
  }

  @HostListener('window:beforeunload')
  public beforeUnload() {
    return !this.gridEditForm?.dirty;
  }

  public override get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public override set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
      this.onClientSelected(value);
      this.refreshSubscriptionInfo();
    }
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.parkerAdministrationService, this.spinnerService),
    });
    this.isActiveColumnName = 'active';
    this.editDialogTitle = 'i18n.domain.parker-administration.edit-parker';
    this.addDialogTitle = 'i18n.domain.parker-administration.add-parker';
    this.addIndexFindColumnName = 'identification';
    this.dialogConfig.width = 1000;
    this.activatedRoute.queryParams.subscribe(params => {
      this.parkerAdministrationService.parkerIdToFilter = params?.parkerId;
      this.grid?.refresh();
    });
    this.refreshSubscriptionInfo();
    this.translationSubscription = this.syncfusionTranslationService.onLanguageChanged.subscribe((lang: string) => {
      // syncfusion grid has an issue with changing the language after the grid when date format is used -> thas is a workaround
      if (this.parkerAdministrationService.parkerIdToFilter != null) {
        this.router.navigate([], { queryParams: { } }).then(() => {
          location.reload();
        });
        return;
      }
      location.reload();
    });
    this.translationSubscription.add(this.translateService.get('i18n.domain.parker-administration.function-button').subscribe((res) => {
      this.toolbarItems = [
        { text: this.translateService.instant('i18n.domain.parker-administration.add-parker'), prefixIcon: "e-icons icon-add", id: 'add' },
        { text: "𝑓(x) " + this.translateService.instant('i18n.domain.parker-administration.function-button'), id: 'fnButton', disabled: true },
        'ColumnChooser'
      ];
    }));
  }

  public ngOnDestroy(): void {
    this.parkerAdministrationService.parkerIdToFilter = null;
    this.translationSubscription?.unsubscribe();
  }

  public getControlPlate(field: string, data: any, column: any): string {
    return data[field].filter(s => s.active && s.usage == ParkerTagUsage.CommonTag)
      .map(s => s.controlPlateNumber?.toUpperCase() ?? s.identificationCode ?? s.barcode ?? null)
      .join(', ');
  }

  public getSubscriptionNamesAsString(data: ParkerDTO): string {
    // array to string concatenated with ', '
    return data.parkerSubscriptionAssignments?.filter(e => e.active).map(s => s.subscription.name).join(', ');
  }

  public formatCurrency(data: ParkerDTO){
    return Currency[data.billingCurrency];
  }

  public formatGroup(data: ParkerDTO): string {
    return 'i18n.domain.parker-administration.enums.group-type.' + ParkerGroup[data.group];
  }

  public formatCreationType(data: ParkerDTO): string {
    return 'i18n.domain.parker-administration.enums.parker-creation-type.' + ParkerCreationType[data.creationType];
  }

  public dataBound(): void {
    if (this.parkerAdministrationService.parkerIdToFilter) {
      const rowIndex = this.grid.getRowIndexByPrimaryKey(+this.parkerAdministrationService.parkerIdToFilter);
      if (rowIndex > -1) {
        this.grid.selectRow(rowIndex);
        this.grid.startEdit();
      }
    }
    // update function button state
    this.updateFunctionButtonState(this.parkerAdministrationService.numTotalRecordsFound > 0);
  }

  public rowDataBound(args: RowDataBoundEventArgs): void {
    // set button icons dynamically
    const parker = args.data as ParkerDTO;
    const buttonElement = args.row.querySelector('.e-unboundcelldiv')?.lastElementChild;
    const linkStatus = this.getParkerLinkStatus(parker);
    args.row.querySelector('.e-unboundcelldiv')?.classList.add('variable-buttons');
    switch (linkStatus) {
      case ParkerLinkStatus.Unlinkable: {
        buttonElement?.classList.add('e-hide');
        break;
      }
      case ParkerLinkStatus.ReadyToLink: {
        buttonElement?.firstElementChild?.classList.add('icon-mail--all');
        (buttonElement as any).title = this.translateService.instant('i18n.domain.parker-administration.send-link');
        break;
      }
      case ParkerLinkStatus.LinkPending: {
        buttonElement?.firstElementChild?.classList.add('icon-mail--reply');
        (buttonElement as any).title = this.translateService.instant('i18n.domain.parker-administration.resend-link');
        break;
      }
      case ParkerLinkStatus.LinkExpired: {
        buttonElement?.firstElementChild?.classList.add('icon-mail--reply', 'e-danger');
        (buttonElement as any).title = this.translateService.instant('i18n.domain.parker-administration.resend-link-upon-expiration');
        break;
      }
      case ParkerLinkStatus.Linked: {
        buttonElement?.firstElementChild?.classList.add('icon-unlink');
        (buttonElement as any).title = this.translateService.instant('i18n.domain.parker-administration.unlink');
        break;
      }
    }
  }

  public commandClicked(args: CommandClickEventArgs): void {
    if (args.commandColumn.type === SfCommandButtonType.None) {
      const parker = args.rowData as ParkerDTO;
      const linkStatus = this.getParkerLinkStatus(parker);

      if (linkStatus === ParkerLinkStatus.Linked) {
        const dialog = this.modalService.showOkCancelDialog('i18n.domain.parker-administration.unlink', 'i18n.domain.parker-administration.unlink-question');
        dialog.onOkSubject.subscribe(() => {
          this.parkerAdministrationService.unlinkUserFromParker(parker.id).subscribe(() => {
            this.grid.refresh();
          });
        });
        return;
      }

      if (linkStatus === ParkerLinkStatus.LinkPending || linkStatus === ParkerLinkStatus.ReadyToLink || linkStatus === ParkerLinkStatus.LinkExpired) {
        this.parkerAdministrationService.initializeParkerToUserLink(parker.id).subscribe(() => {
          this.grid.refresh();
        });
      }
    }
  }

  public getFilterItem(data) {
    return data.name;
  }

  public override actionBegin(args: any) {
    const rowParker = args.rowData as ParkerDTO;
    if (!this.loadedParker && rowParker?.id) {
      this.spinnerService.showSpinner = true;
      args.cancel = true;
      this.parkerClient.getParker(rowParker.id, false)
        .subscribe(
          {
            next: (parker) => {
              this.loadedParker = parker;
              this.grid.selectRow(this.grid.getRowIndexByPrimaryKey(rowParker.id));
              this.grid.startEdit();
              this.spinnerService.showSpinner = false;
            }, error: () => {
              this.spinnerService.showSpinner = false;
            }
          });
    } else {
      super.actionBegin(args);
    }

    if (args.requestType === SfRequestTypes.FilterBeforeOpen && args.columnName === this.subscriptionAssignmentField) {
      args.filterModel.options.dataSource = new EnumFilterDataManager<any>(this.subscriptionFilterSource);
    }
    if (args.requestType === SfRequestTypes.FilterChoiceRequest && args.columnName === this.subscriptionAssignmentField) {
      args.query.distincts = []; // will set custom trigger flag and avoid filtering the list for distinct values of the enum filter field
      args.filterModel.options.dataManager = null;
    }
  }

  public override actionComplete(args) {
    if (args.requestType === SfRequestTypes.Save || args.requestType === SfRequestTypes.Cancel) {
      this.loadedParker = null;
    }
    super.actionComplete(args);
  }

  protected initializeEditForm(data: ParkerDTO): void {
    if (this.loadedParker) {
      data = this.loadedParker;
    }

    this.gridEditForm = this.fb.group<EditParkerFormType>({
      id: this.fb.control<number>(data.id),
      firstName: this.fb.control<string>(data.firstName, Validators.required),
      lastName: this.fb.control<string>(data.lastName, Validators.required),
      identification: this.fb.control<string>(data.identification, Validators.maxLength(50)),
      group: this.fb.control<ParkerGroup>(data.group ?? ParkerGroup.Undefined),
      companyId: this.fb.control<number>(data.company?.id),
      costCenter: this.fb.control<string>(data.costCenter),
      title: this.fb.control<string>(data.title),
      address: this.fb.control<string>(data.address),
      zip: this.fb.control<string>(data.zip, CustomValidatorsFactory.createZipValidator()),
      city: this.fb.control<string>(data.city),
      country: this.fb.control<string>(data.country),
      privateAddress: this.fb.control<string>(data.privateAddress),
      privateZip: this.fb.control<string>(data.privateZIP, CustomValidatorsFactory.createZipValidator()),
      privateCity: this.fb.control<string>(data.privateCity),
      privateCountry: this.fb.control<string>(data.privateCountry),
      email: this.fb.control<string>(data.email, Validators.email),
      mobile: this.fb.control<string>(data.mobile, CustomValidatorsFactory.createPhoneValidator()),
      phone: this.fb.control<string>(data.phone, CustomValidatorsFactory.createPhoneValidator()),
      billing: this.fb.control<boolean>(data.billing ?? true),
      workplace: this.fb.control<string>(data.workplace),
      employmentPercentage: this.fb.control<number>(data.employmentPercentage ?? 100, Validators.min(1)),
      active: this.fb.control<boolean>(data.active ?? true),
      billingCurrency: this.fb.control<Currency>(data.billingCurrency ?? Currency.CHF),
      activeParkingPermitGuid: this.fb.control<string>(data.activeParkingPermitGuid),
      parkingPermitValidityPeriod: this.fb.control<number>(data.parkingPermitValidityPeriod ?? 0),
      linkedUser: this.fb.control<string>({ value: data.linkedUserUserName, disabled: true }),
      modifiedBy: this.fb.control<string>({value: data.modifiedBy, disabled: true}),
      modifiedOn: this.fb.control({value: data.modifiedOn ? data.modifiedOn.toFormat('dd.MM.yyyy HH:mm:ss') : null, disabled: true}),
      tags: this.fb.control<ParkerTagDTO[]>(data.tags ?? []),
      parkerSubscriptionAssignments: this.fb.control<ParkerSubscriptionAssignmentDTO[]>(data.parkerSubscriptionAssignments ?? []),
      custom1: this.fb.control<string>(data.custom1),
      custom2: this.fb.control<string>(data.custom2),
      custom3: this.fb.control<string>(data.custom3),
      custom4: this.fb.control<string>(data.custom4),
      custom5: this.fb.control<string>(data.custom5),
      custom6: this.fb.control<string>(data.custom6),
      custom7: this.fb.control<string>(data.custom7),
      custom8: this.fb.control<string>(data.custom8),
      custom9: this.fb.control<string>(data.custom9),
      comment: this.fb.control<string>(data.comment),
      entryDate: this.fb.control<Date>(data.entryDate?.toJSDate() ?? DateTime.now().toJSDate(), Validators.required),
      exitDate: this.fb.control<Date>(data.exitDate?.toJSDate() ?? null),
    });
    this.gridEditForm.controls.exitDate.setValidators(CustomValidatorsFactory.validateDateNotBeforeDate(this.gridEditForm.controls.entryDate));
  }

  protected getEditDialogTitleParams(rowData): any {
    const fullName = rowData.firstName + (rowData.lastName ? (' ' + rowData.lastName) : '');
    return { params: fullName };
  }

  protected override addObjectCompare(addedObject: any, rowObject: any): boolean {
    return addedObject.firstName === rowObject.firstName
      && addedObject.lastName === rowObject.lastName
      && addedObject.identification === rowObject.identification
      && addedObject.address === rowObject.address
      && addedObject.zip === rowObject.zip
      && addedObject.city === rowObject.city
      && addedObject.country === rowObject.country
      && addedObject.email === rowObject.email;
  }

  protected override getDataToSave(): any {
    return {
      ...this.gridEditForm.value,
      parkerSubscriptionAssignments: this.gridEditForm.value.parkerSubscriptionAssignments?.map(assignment => ({
        ...assignment,
        id: assignment.id < 0 ? 0 : assignment.id,
        subscriptionId: assignment.subscription.id,
      })),
      tags: this.gridEditForm.value.tags?.map(tag => ({
        ...tag,
        id: tag.id < 0 ? 0 : tag.id,
      }))
    };
  }

  private getParkerLinkStatus(parker: ParkerDTO): ParkerLinkStatus {
    if (parker.linkedUserUserName) {
      return ParkerLinkStatus.Linked;
    }

    if (parker.userLinkCodeValidUntil) {
      if (parker.userLinkCodeValidUntil < DateTime.now()) {
        return ParkerLinkStatus.LinkExpired;
      }
      return ParkerLinkStatus.LinkPending;
    }

    if (parker.email) {
      return ParkerLinkStatus.ReadyToLink;
    }

    return ParkerLinkStatus.Unlinkable;
  }
  /**
   * onFilterUpdated
   */
  public onFilterUpdated(filters: FilterDTO[]) {
    this.parkerAdministrationService.filters = filters;
    this.grid.refresh();
  }

  public showFunctionDialog() {
    this.parkerFunctionDialog.functionExecuted.subscribe(() => {
      this.grid.refresh();
    });
    let numTotalRecordsToWorkOn = this.grid.getSelectedRecords().length;
    if (numTotalRecordsToWorkOn <= 0) {
      numTotalRecordsToWorkOn = this.parkerAdministrationService.numTotalRecordsFound;
    }
    if (this.grid.getSelectedRecords().length > 0) {
      this.parkerFunctionDialog.openDialog(numTotalRecordsToWorkOn, this.loadPagedParkersForFunctions.bind(this));
    } else {
      this.modalHelperService.confirm(
        'i18n.domain.parker-administration.confirm-all.title',
        this.translateService.instant('i18n.domain.parker-administration.confirm-all.content', {numParkers: numTotalRecordsToWorkOn}),
        () => this.parkerFunctionDialog.openDialog(numTotalRecordsToWorkOn, this.loadPagedParkersForFunctions.bind(this)),
      );
    }
  }

  public onToolbarCommandClick(args: ClickEventArgs) {
    if (args.item.id === 'fnButton' && this.parkerAdministrationService.numTotalRecordsFound > 0) {
      this.showFunctionDialog();
    } else if (args.item.id === 'add') {
      this.grid.addRecord();
    }
  }

  public loadPagedParkersForFunctions(skip: number, take: number): Observable<PagedResultDTOOfParkerDTO> {
    const selectedRecords = this.grid.getSelectedRecords() as ParkerDTO[];
    if (selectedRecords.length > 0) {
      if (skip < selectedRecords.length) {
        const subSelection = selectedRecords.slice(skip, skip + take);
        return of(new PagedResultDTOOfParkerDTO({ items: subSelection, totalNumberOfItems: selectedRecords.length }));
      }
      return of(new PagedResultDTOOfParkerDTO({ items: [], totalNumberOfItems: selectedRecords.length }));
    }
    return this.parkerAdministrationService.loadPagedParkersForFunctions(skip, take);
  }

  private updateFunctionButtonState(enableButton: boolean) {
    if (enableButton) {
      this.toolbar = [
        this.toolbarItems[0],
        { text: this.toolbarItems[1].text, id: this.toolbarItems[1].id },
        this.toolbarItems[2]
      ]
    }
    else {
      this.toolbar = [
        this.toolbarItems[0],
        { text: this.toolbarItems[1].text, id: this.toolbarItems[1].id, disabled: true },
        this.toolbarItems[2]
      ]
    }
  }

  private refreshSubscriptionInfo() {
    this.parkerAdministrationService.loadSubscriptions().subscribe(result => {
      if (!result) {
        return;
      }
      this.refreshSubscriptionFilterSource(result?.items);
    });
  }

  private refreshSubscriptionFilterSource(subscriptions: ParkingSubscriptionDTO[]): void {
    this.subscriptionFilterSource = subscriptions?.map(s => {
      const item = {id: s.id, name: s.name};
      item[this.subscriptionAssignmentField] = s.name; // since syncfusion is using this field for displaying and is also automatically sorting on it - we have to use the name:(
      return item;
    }) ?? [];
  }
}
